<div class="quick-addtimesheet-popup-container" data-testid="quick-add-timesheet">
  <form class="">
    <div class="cmn-modal-header">
      <h4 class="modal-header-title">
        {{
        (timesheetName || 'My Timesheet') === 'My Timesheet'
        ? (sourceComponent === 'NewTimesheetComponent' && (selectedDataAlt?.clientId || selectedDataAlt?.clientId ===
        0))
        ? 'Update time log'
        : 'Add time log'
        : (sourceComponent === 'NewTimesheetComponent' && (selectedDataAlt?.clientId || selectedDataAlt?.clientId ===
        0))
        ? 'Update time log for ' + timesheetName
        : 'Add time log for ' + timesheetName
        }}
        <span class="quickadd-status-indication" *ngIf="selectedDataAlt?.statusId == 1">
          <img src="../../../assets/img/timesheet/gray-edit-ic.svg" alt="icon" />
        </span>
        <span class="quickadd-status-indication" *ngIf="selectedDataAlt?.statusId == 2">
          <img src="../../../assets/img/timesheet/blue-edit-ic.svg" alt="icon" />
        </span>
        <span class="quickadd-status-indication" *ngIf="selectedDataAlt?.statusId == 3">
          <img src="../../../assets/img/timesheet/review.svg" alt="icon" />
        </span>
        <span class="quickadd-status-indication" *ngIf="selectedDataAlt?.statusId == 4">
          <img src="../../../assets/img/timesheet/green-checkmark-ic.svg" alt="icon" />
        </span>
        <span class="quickadd-status-indication reject-indi-img" *ngIf="selectedDataAlt?.statusId == 5">
          <img src="../../../assets/img/timesheet/rejected-timesheet-ic.svg" alt="icon" />
        </span>
      </h4>
    </div>
    <div class="cmn-modal-content">
      <div class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label col-2 mb-0">
            Client<span class="error-text">*</span>
          </h6>
          <div class="col-10">
            <div class="form-select-container" [ngClass]="{ 'pale-green-bg': isHoliday }">
              <ng-select #clientDropdown data-testid="drpdwn-client-add-tmsheet" [items]="dropdownItemList" class="cmn-ngselect clientaddnew-drdwn" bindLabel="displayClientName"
                bindValue="displayClientName" name="clients" [clearable]="true"
                [virtualScroll]="true" placeholder="Select client" [(ngModel)]="quickAddSelectedTimesheetClient"
                (change)="timesheetClientColDropdown($event); onFieldChange()"
                (clear)="timesheetClientColDropdownClear()"
                [searchFn]="customClientSearch"
                [disabled]="!isClientDisabled || selectedDataAlt?.isFinalOrStandardInvoice" [selectOnTab]="true"
                (focus)="outsideUnit()"  [searchable]="true"  (keydown)="onClientDropdownKeydown($event)"
                (keyup)="onClientDropdownKeyup($event)"
                (mousedown)="onClientDropdownMousedown($event)"  required >
                  <ng-template ng-header-tmp>
                    <div class="client-tabs-container">
                  
                      <button type="button" class="client-tab" data-testid="tab-billable-client-add-tmsheet" [class.active]="activeClientTab === 'billable'"
                        (click)="setClientTab('billable')" [attr.aria-keyshortcuts]="'Alt+B'" title="Billable (Alt+B)">
                        Billable
                        <span class="keytip-badge" *ngIf="isAltShortcutActive">B</span>
                      </button>
                  
                      <button type="button" class="client-tab" data-testid="tab-non-billable-client-add-tmsheet" [class.active]="activeClientTab === 'non-billable'"
                        (click)="setClientTab('non-billable')" [attr.aria-keyshortcuts]="'Alt+N'" title="Non-billable (Alt+N)">
                        Non-billable
                        <span class="keytip-badge" *ngIf="isAltShortcutActive">N</span>
                      </button>
                  
                    </div>
                  </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label col-2 mb-0">
            Job<span class="error-text">*</span>
          </h6>
          <div class="col-10">
            <div class="form-select-container">
              <ng-select #jobDropdown data-testid="drpdwn-job-add-tmsheet" [items]="timesheetJobList" class="cmn-ngselect" bindLabel="displayJobName"
                bindValue="jobId" name="jobS" [clearable]="true" [virtualScroll]="true" placeholder="Select job"
                [readonly]="isJobDropdownDisabled || selectedDataAlt?.isFinalOrStandardInvoice"
                [(ngModel)]="selectedTimesheetJob" (clear)="timesheetJobColDropdownClear()" [selectOnTab]="true"
                (focus)="outsideUnit()" (ngModelChange)="timesheetJobColDropdown(); onFieldChange(); isFormValid();"
                required>
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div class="joblistdropdown-item-name" [ngClass]="{'disableJobItem':item.isWIPPeriodClosed}">
                    {{item.displayJobName}} <img *ngIf="item.isWIPPeriodClosed"
                      src="../../../assets/img/table-info-blue-ic.svg" class="ml-1 closedwip-tooltip-ic" alt="icon"
                      matTooltipClass="cmn-tooltip-template light-tooltip-template"
                      matTooltip="WIP period has been closed for this date.">
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!_timeSheetlevel" class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label col-2 mb-0">
            Task<span class="error-text">*</span>
          </h6>
          <div class="col-10">
            <div class="form-select-container">
              <ng-select #taskDropdown data-testid="drpdwn-task-add-tmsheet" [items]="timesheetTaskList" class="cmn-ngselect" bindLabel="taskTitle"
                bindValue="taskId" name="tasks" [clearable]="true" [virtualScroll]="true" placeholder="Select task"
                [readonly]="isTaskDropdownDisabled || selectedDataAlt?.isFinalOrStandardInvoice"
                (clear)="timesheetTaskColDropdownClear()" [selectOnTab]="true" (focus)="outsideUnit()"
                [(ngModel)]="selectedTimesheetTask"
                (ngModelChange)="timesheetTaskColDropdown(); onFieldChange(); isFormValid();" required>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label col-2 mb-0">
            Date<span class="error-text">*</span>
          </h6>
          <div class="col-10">
            <div class="input-wth-info-text">
              <div class="form-datepicker-container w-180 cmn-material-datepicker">
                <mat-form-field floatLabel="never" appearance="standard">
                  <input class="cmn-mat-dtpicker-input" data-testid="inp-date-add-tmsheet" matInput [matDatepicker]="quickTimesheetDatePicker"
                         name="quickTimeDate" [disabled]="!isDateFieldsEnabled" autocomplete="off" placeholder="dd/mm/yyyy"
                         [(ngModel)]="timesheetdatePickerdefault"
                         (ngModelChange)="onDateSelection($event); onFieldChange(); isFormValid();" required
                         [matDatepickerFilter]="dateFilter">
                  <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" data-testid="btn-open-date-picker-add-tmsheet" matIconSuffix
                                         [for]="quickTimesheetDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker panelClass="cmn-datepicker-ui" #quickTimesheetDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <span *ngIf="!isUserAllowedToLog" class="disabled-kc-cmd-timesheet ml-3">
                You cannot add timesheet entry for this day
              </span>
            </div>
            </div>
        </div>
      </div>
      <div class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label col-2 mb-0">
            Start time
          </h6>
          <div class="col-10">
            <div class="form-timepicker-container w-180">
              <ejs-timepicker data-testid="inp-start-time-add-tmsheet" cssClass="cmn-timepicker-container quickAddTimepickerPoup" name="timesheetStartTimePicker"
                placeholder="hh:mm pm" [enableMask]="true" format="hh:mm a"
                [maskPlaceholder]="timePickerMaskPlaceholderValue" [allowEdit]="true"
                [step]="_timeSheetFormat ? (sourceComponent === 'NewTimesheetComponent' ? (selectedDataAlt?.unitValue || _timeSheetUnitVal) : _timeSheetUnitVal) : 30"
                (blur)="onFocusStartTime($event)" [(ngModel)]="startDateTime"
                (change)="startTimeLog($event); onFieldChange(); isFormValid();"
                [enabled]="!selectedDataAlt?.isFinalOrStandardInvoice && isStartTimeFieldsEnabled">
              </ejs-timepicker>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="_timeSheetFormat" class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label col-2 mb-0 d-flex">
            Unit<span class="error-text">*</span>
            <img src="../../../assets/img/table-info-blue-ic.svg" class="ml-1 unit-info-img" alt="icon"
              matTooltipClass="cmn-tooltip-template light-tooltip-template"
              matTooltip="1 unit = {{sourceComponent == 'NewTimesheetComponent' ? (selectedDataAlt?.unitValue || _timeSheetUnitVal) : _timeSheetUnitVal}} minutes">
          </h6>
          <div class="col-10">
            <div class="input-wth-info-text">
              <div class="form-input-container w-180 normal-placeholder-text">
                <input #unitquicktime data-testid="inp-units-add-tmsheet" type="text" class="form-control" placeholder="Units"
                  [disabled]="!isUnitFieldsEnabled || selectedDataAlt?.isFinalOrStandardInvoice" name="units"
                  [(ngModel)]="selectedUnitValue" (ngModelChange)="calculateTime(); onFieldChange(); isFormValid();"
                  (keypress)="numberOnly($event)" (blur)="outsideClick($event);"
                  (keydown.tab)="moveFocusToDescription($event)">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label col-2 mb-0 d-flex">
            <!-- if time level then star should visible -->
            Time
          </h6>
          <div class="col-10">
            <div class="input-wth-info-text">
              <div class="form-input-container w-180 normal-placeholder-text">
                <input #quicktime data-testid="inp-duration-add-tmsheet" type="text" class="form-control" placeholder="hh:mm" name="time"
                  [(ngModel)]="calculatedTime"
                  [disabled]="!isTimeFieldEnabled || selectedDataAlt?.isFinalOrStandardInvoice"
                  (input)="handleTimeInput($event); onFieldChange()" (focusout)="convertMinutesToTime()"
                  (blur)="outsideClick($event);" (keydown.tab)="moveFocusToDescription($event)">
              </div>
              <span class="logged-details-txt">Logged {{totalDurationSum ? totalDurationSum + ' h' : '0:00 h'}} for the
                day</span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group form-group-sm">
        <div class="custom-row align-items-center">
          <h6 class="cmn-form-label col-2 mb-0">
            Rate
          </h6>
          <div class="col-10">
            <div class="form-select-container w-180 quickadd-rate-drpdwn cmn-rate-dropdown-template">
              <ng-select data-testid="drpdwn-bill-rate-add-tmsheet" [items]="rateListData" class="cmn-ngselect" bindLabel="billRate" bindValue="billRate"
                [clearable]="false" [searchable]="false" placeholder="$0.00"
                [disabled]="!isRateFieldEnabled || disableRate || selectedDataAlt?.isFinalOrStandardInvoice"
                [(ngModel)]="selectedDefaultRate" (ngModelChange)="onFieldChange()">
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <div class="cmn-rate-dropdown-option-tmp">
                    <span class="rate-desc-text" title="{{ item.description }}">{{ item.description }}</span>
                    <span>{{ item.billRate | currency:'AUD':'$'}}</span>
                  </div>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  <span title="{{ item.billRate | currency:'AUD':'$'}}">{{ item.billRate | currency:'AUD':'$'}}</span>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group form-group-sm">
        <div class="custom-row align-items-start">
          <h6 class="cmn-form-label col-2 pt-2">Description</h6>
          <div class="col-10">
            <div class="form-textarea-container normal-placeholder-text">
              <textarea #descpquicktime data-testid="txtarea-description-add-tmsheet" class="form-control" name="description"
                placeholder="Please add your description here" rows="5"
                [disabled]="!isCommentFieldsEnabled || selectedDataAlt?.isFinalOrStandardInvoice"
                [(ngModel)]="selectedComment" (ngModelChange)="onFieldChange()" maxlength="500" tabindex="1"></textarea>
              <div class="description-validation-counter">
                <span class="invalid-feedback invalid" *ngIf="selectedComment?.length === 500">Character limit reached
                  (500 character)</span>
                <span class="des-counter-value">{{ selectedComment?.length || 0 }}/500</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cmn-modal-footer">
      <button
        *ngIf="sourceComponent == 'NewTimesheetComponent' && canShowEditDeleteContainer(selectedDataAlt)"
        type="button" mat-button class="quickaddtimsht-delete-btn cmn-delete-btn mr-auto" data-testid="btn-delete-add-tmsheet" tabindex="-1"
        (click)="deleteLoggedData()">Delete</button>
      <button type="button" mat-button class="cmn-blue-btn mr-2" data-testid="btn-save-add-tmsheet" tabindex="2" (click)="addDailyLogData()"
        [disabled]="disableAddButton || !isFormValid()">{{ sourceComponent === 'NewTimesheetComponent' ?
        (selectedDataAlt && (selectedDataAlt.clientId === 0 || selectedDataAlt.clientId) ? 'Update' : 'Add') : 'Publish'
        }}</button>
      <button type="button" mat-button class="cmn-inverse-btn" data-testid="btn-cancel-add-tmsheet" tabindex="3"
        (click)="closeQuickAddpopup()">Cancel</button>
    </div>
  </form>
</div>
